import { ManagedBy, TestCard } from "@app/provider/testData/types";
import { IntlShape } from "react-intl/src/types";
import { messages } from "@app/provider/testData/messages";
import { OncologyTestCardBase } from "@app/provider/testData/testCard/oncology/OncologyTestCardBase";
import { getEstimatedResultsDeliveryDate } from "@app/utils/getEstimatedResultsDeliveryDate";
import { Utils } from "@natera/material/lib/date";
import { convertSampleCollectionDate } from "@app/utils";

export class LatitudeTestCard extends OncologyTestCardBase {
  protected getDescriptionForUpcomingTest(
    testCard: TestCard,
    intl: IntlShape
  ): string | undefined {
    if (testCard.managedBy === ManagedBy.CLINIC) {
      return intl.formatMessage(
        messages.testCardSignateraOrderedByClinicSubsequentTestDesc
      );
    }

    if (
      testCard.managedBy === ManagedBy.NATERA &&
      testCard.sampleCollectionDate
    ) {
      return intl.formatMessage(
        messages.testCardOncologyManagedByNateraTestOrderedSampleCollectionDate,
        {
          sampleCollectionDate: convertSampleCollectionDate(
            new Date(testCard.sampleCollectionDate).toISOString()
          ),
        }
      );
    }

    return intl.formatMessage(
      messages.testCardOncologyManagedByNateraTestOrdered
    );
  }

  protected getDescriptionForSampleReceived(
    testCard: TestCard,
    intl: IntlShape
  ): string | undefined {
    if (testCard.sampleReceivedDate) {
      if (testCard.isReflexed) {
        return intl.formatMessage(
          messages.testCardDescSampleReceivedIsReflexed
        );
      }
      const estimatedResultsDeliveryDate = Utils.getUSLocaleDate(
        getEstimatedResultsDeliveryDate(
          testCard,
          new Date(testCard.sampleReceivedDate)
        )
      );
      return intl.formatMessage(messages.testCardDescSampleReceived, {
        estimatedResultsDate: estimatedResultsDeliveryDate,
      });
    }
    return intl.formatMessage(messages.testCardDescSample);
  }
}
